import { render, staticRenderFns } from "./FormPoliciesGroup.vue?vue&type=template&id=5953beb4&scoped=true&"
import script from "./FormPoliciesGroup.vue?vue&type=script&lang=js&"
export * from "./FormPoliciesGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormPoliciesGroup.vue?vue&type=style&index=0&id=5953beb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5953beb4",
  null
  
)

export default component.exports